const Register = {
    username: '',
    password: '',
    passwordconfirmation: '',
    email: ''
}

export default Register;